module.exports = __webpack_public_path__ + "img/fats-segment.d927a10d.png";